export const Unctad16Section = ({ children }) => children;
export const AtAGlanceSection = ({ children }) => children;
export const KeyMomentsSection = ({ children }) => children;
